import React, { useState, useEffect } from "react";
import QuestionTitle from "../QuestionTitle";
import { useSelector, useDispatch } from "react-redux";
// import PuzzleImg from "../../../../../assets/images/joftPooch/puzzleImage.jpg";
import Puzzle from "./Puzzle";
import { baseURL } from "../../../../../assets/constants/baseUrl";
import { setQuestionAnswer } from "../../../../../assets/redux/actions/Quiz";

export default function PuzzleQuestion() {
  const dispatch = useDispatch();
  const { currentQuestion, rightAnswer } = useSelector(({ quiz }) => quiz);
  const [solved, setSolved] = useState(false);
  const [src, setSrc] = useState("");

  useEffect(() => {
    if (currentQuestion) {
      const fetchData = async () => {
        fetch(`${baseURL}file/get/${currentQuestion.puzzleSource}`, {
          mode: "cors",
          credentials: "omit",
        })
          .then((response) => response.blob())
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            setSrc(url);
          })
          .catch((error) => {
            console.error("Error fetching the data:", error);
          });
      };

      fetchData();
    }
  }, [currentQuestion]);

  useEffect(() => {
    if (currentQuestion) {
      setSrc(`${baseURL}file/get/${currentQuestion.puzzleSource}`);
      if (rightAnswer) {
        dispatch(
          setQuestionAnswer({
            questionId: currentQuestion._id,
            rightAnswer: true,
          })
        );
      } else {
        dispatch(
          setQuestionAnswer({
            questionId: currentQuestion._id,
            rightAnswer: solved,
          })
        );
      }
    }
    return () => {
      dispatch(setQuestionAnswer(null));
    };
  }, [solved, currentQuestion, dispatch, rightAnswer]);

  return (
    <div className="w-100">
      <QuestionTitle
        title={currentQuestion?.title}
        imgSrc={
          currentQuestion
            ? `${baseURL}file/get/${currentQuestion.puzzleSource}`
            : ""
        }
        noBg
        puzzle
      />
      {currentQuestion && (
        <Puzzle
          imgSrc={src}
          rows={currentQuestion.puzzleRow}
          cols={currentQuestion.puzzleColumn}
          handleSolve={(solved) => setSolved(solved)}
        />
      )}
    </div>
  );
}
